module.exports = __webpack_public_path__ + "4178acaf76f16c17649d5a0b7450eedf.MP3";